import { useContext } from 'react';
import { currentSecondaryDimensionContext } from './context';
export var useCurrentSecondaryDimension = function () {
    var currentSecondaryDimension = useContext(currentSecondaryDimensionContext);
    return currentSecondaryDimension;
};
